// FILEPATH: /C:/Open_market/formulario_contacto_empresas/src/__tests__/components/core/LottieLoader.test.js

import { shallowMount } from "@vue/test-utils";
import LottieLoader from "@/components/core/LottieLoader";

describe("LottieLoader.vue", () => {
  it("renders lottie component", () => {
    const wrapper = shallowMount(LottieLoader);
    expect(wrapper.find("lottie-stub").exists()).toBe(true);
  });

  it("passes a binded prop to lottie component", () => {
    const wrapper = shallowMount(LottieLoader);
    expect(wrapper.find("lottie-stub").attributes("options")).toBeTruthy();
  });

  it("passes a binded height to lottie component", () => {
    const wrapper = shallowMount(LottieLoader);
    expect(wrapper.find("lottie-stub").attributes("height")).toBe("96");
  });

  it("passes a binded width to lottie component", () => {
    const wrapper = shallowMount(LottieLoader);
    expect(wrapper.find("lottie-stub").attributes("width")).toBe("96");
  });

  /*    it('listens to animCreated event', () => {
            const wrapper = shallowMount(LottieLoader);
            expect(wrapper.find('lottie-stub').attributes('onanimcreated')).toBeTruthy();
        });*/
});
